import { createComponent } from '@lit/react';
import { Footer } from '@pocketoutdoormedia/footer-wc';
import { EVENTS } from 'helpers/outside-packages/constants';
import { getNavigationConfig } from 'helpers/outside-packages/getNavigationConfig';
import { useOutsidePackagesUserData } from 'helpers/outside-packages/useOutsidePackagesUserData';
import type { CSSProperties } from 'react';
import React from 'react';

const FooterLitComponent = createComponent({
  elementClass: Footer,
  events: EVENTS,
  react: React,
  tagName: 'out-footer'
});

const FooterWC = () => {
  const navConfig = getNavigationConfig();
  const { footerUserData } = useOutsidePackagesUserData();

  return (
    <FooterLitComponent
      className="relative"
      style={
        {
          '--outside-footer-max-width': '100%'
        } as CSSProperties
      }
      theme="light"
      userData={footerUserData}
      {...navConfig}
    >
      <button
        className="cmp-revoke-consent static p-0 text-12 font-medium text-btn-disabled-text hover:text-btn-secondary-hover"
        slot="manage-cookies-button"
        type="button"
      >
        Manage Cookie Preferences
      </button>
    </FooterLitComponent>
  );
};

export default FooterWC;
